import React, { ErrorInfo } from 'react';

import { css } from '@emotion/react';

import { trackErrors } from 'src/utils/analytics/newrelic/RUMHelper';

import { MediaBP as MQ } from '../../styles/mediaQuery';
import { Fallback_Type_Constants } from '../../utils/constants/FallbackTypeConstants';
import Fallback from '../Fallback/Fallback';

class ErrorBoundary extends React.Component<
  { children: JSX.Element; isHeaderPresent: boolean },
  { hasError: boolean }
> {
  errorBoundayContainer = css`
    min-height: 660px;
    padding-top: 55px;
  `;
  componentContainerWithHeader = css`
    flex: 1;
    margin-top: 44px;
    ${MQ.MediaSm} {
      margin-top: 64px;
    }
    ${MQ.MediaLg} {
      margin-top: 80px;
    }
  `;

  componentContainerWithoutHeader = css`
    flex: 1;
  `;

  constructor(
    props:
      | { children: JSX.Element; isHeaderPresent: boolean }
      | Readonly<{ children: JSX.Element; isHeaderPresent: boolean }>
  ) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    try {
      error.message = `ErrorBoundary : ${error.message}`;
    } catch (err) {
      console.error(err);
    }
    trackErrors(error, errorInfo);
  }

  retryHandler = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          data-test-id="errorBoundayContainer"
          css={this.errorBoundayContainer}>
          <Fallback
            type={Fallback_Type_Constants.SOMETHING_WENT_WRONG}
            retry={this.retryHandler}
          />
        </div>
      );
    }
    return (
      <div
        data-test-id="componentContainer"
        css={
          this.props.isHeaderPresent
            ? this.componentContainerWithHeader
            : this.componentContainerWithoutHeader
        }>
        {this.props.children}
      </div>
    );
  }
}

export default ErrorBoundary;
